<template>
<div v-if="!!menuItem" id="CartMenuItemDisplay">
  <v-layout row justify-space-between :align-center="!isSide" :align-end="isSide">
    <v-flex v-if="!isSide && !immutable" xs4>
      <v-layout row justify-space-between align-center>
        <v-flex xs5 class="text-xs-center">
          <v-btn outline :disabled="cartIsLoading" @click="handleDecrement(index)" flat icon small color="primary">
            <v-icon>remove</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs2 class="text-xs-center">
          {{ menuItem.qty }}
        </v-flex>

        <v-flex xs5 class="text-xs-center">
          <v-btn :disabled="(!storeIsAvailable && !$store.getters['groupOrder/isInGroupOrder']) || cartIsLoading" outline @click="handleIncrement(index)" flat icon small color="primary">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex
      :xs6="!isSide && !immutable"
      :xs9="isSide || immutable"
      :offset-xs1="isSide"
      :class="{ 'clickable-item': !immutable }"
      @click="initEdit(menuItem, index)"
    >
      <div :style="isSide || immutable ? 'padding-left: 16px !important' : null">
        <span v-if="'qty' in menuItem && menuItem.qty > 1 && (isSide || immutable)">{{menuItem.qty}} <span class="caption grey--text" style="font-weight: 700;">x</span></span><b>{{findDisplayText(menuItem) | capatalize}}</b>
        <v-icon v-if="punchCardApplied" style="float: right; margin-right: 5px">
          loyalty
        </v-icon>
      </div>
    </v-flex>

    <v-flex xs2 @click="initEdit(menuItem, index)" class="text-xs-right" :class="{'grey--text': isSide, 'clickable-item': !immutable}">
      <template v-if="!menuItem.subTotal && applyPunchCards(menuItem)">
        <div class="price-container">
          <span class="mr-1 caption grey--text" style="text-decoration: line-through;">{{ quantity*applyPunchCards(menuItem) | currency }}</span>
          <span class="red--text">{{ quantity*sumLocalMenuItem(menuItem) | currency }}</span>
        </div>
      </template>
      <template v-else-if="isQuantityBasedPromotion">
        <template v-if="parseFloat((menuItem.price || menuItem.itemPrice)*menuItem.qty) <= parseFloat(getOriginalPrice*menuItem.qty)">
          <div class="price-container">
            <span
              v-if="(quantity * getOriginalPrice * menuItem.qty) !== (quantity * (menuItem.price || menuItem.itemPrice) * menuItem.qty)"
              class="mr-1 caption grey--text strikethrough-price"
            >
              {{ quantity * getOriginalPrice * menuItem.qty | currency }}
            </span>
            <span
              :class="{
                'discounted-price': true,
                'red--text': (quantity * getOriginalPrice * menuItem.qty) !== (quantity * (menuItem.price || menuItem.itemPrice) * menuItem.qty) && !isSide
              }"
              style="color: inherit;"
            >
              {{ quantity * (menuItem.price || menuItem.itemPrice) * menuItem.qty | currency }}
            </span>
          </div>
        </template>
        <template v-else>
            {{ quantity*getLowestNonZero(menuItem.itemPrice, menuItem.price)*menuItem.qty | currency }}
        </template>
      </template>
      <template v-else-if="parseFloat(getOriginalPrice) > parseFloat(menuItem.itemPrice)">
        <div class="price-container">
          <span class="mr-1 caption grey--text strikethrough-price">{{ quantity*getOriginalPrice*menuItem.qty | currency }}</span>
          <span :class="isSide ? '' : 'red--text'" class="discounted-price">{{ quantity*(menuItem.price)*menuItem.qty | currency }}</span>
        </div>
      </template>
      <template v-else-if="menuItem.unitPrice">{{ quantity*menuItem.unitPrice*menuItem.qty | currency }}</template>
      <template v-else-if="menuItem.itemPrice">{{ quantity*menuItem.itemPrice*menuItem.qty | currency }}</template>
      <template v-else-if="price">{{ quantity*price*menuItem.qty | currency }}</template>
      <template v-else>{{ quantity*(menuItem.subTotal || 0) + ((menuItem.promotionDiscountAmount || 0) / 100) | currency }}</template>
    </v-flex>
  </v-layout>

  <ul class="cart-list" :class="{ 'clickable-item': !immutable }" @click="initEdit(menuItem, index)">
    <li v-for="promotion in (menuItem.promotionDiscounts || [])">
      <v-layout row justify-space-between align-center>
        <v-flex :offset-xs4="!isSide && !immutable" :offset-xs2="isSide" :offset-xs1="immutable" xs6 class="grey--text">{{ findDisplayText(promotion) }}</v-flex>
        <v-flex class="text-xs-right" xs2>{{ promotion.amount / 100 | currency }}</v-flex>
      </v-layout>
    </li>


    <template v-for="modifier in menuItem.itemAttributeList">
      <li v-for="(config, configIndex) in groupOptions(modifier)" :key="`${modifier.code}_${configIndex}`">
        <div v-if="modifier.pizzaTopping && 'option' in config && getOptionText(configIndex, groupOptions(modifier))" style="position: relative; left: 23%; display: block; height: 12px; margin-top: 3px">
          <b>{{ getOptionText(configIndex, groupOptions(modifier)) }}</b>
        </div>

        <v-layout row justify-space-between align-center>
          <v-flex :offset-xs4="!isSide && !immutable" :offset-xs2="isSide" :offset-xs1="immutable" xs6 class="pt-1">
            <span v-if="'qty' in config && config.qty > 1">{{config.qty}} <span class="caption grey--text" style="font-weight: 700;">x</span>
          </span>
            <span v-text="findDisplayText(config)"></span>
          </v-flex>

          <v-flex class="text-xs-right caption grey--text" xs2>
            <span v-if="'price' in config">
              {{ quantity*menuItem.qty*config.price | currency }}
            </span>
            <common-price v-else
              :init-quantity="quantity*menuItem.qty"
              :only-final-value="true"
              :init-charges="config.charges || []"
            />
          </v-flex>
        </v-layout>
      </li>
    </template>

    <li>
      <v-layout row justify-space-between align-center>
        <v-flex offset-xs4 class="pt-1 special-request">
          {{menuItem.specialRequest}}
        </v-flex>
      </v-layout>
    </li>
  </ul>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import get from 'lodash/get';

import { matchTranslation } from "@/services/util.service"

import CommonPrice from './Common/CommonPrice'

export default {
  props: {
    parent: {
      type: Object,
      required: false
    },
    item: Object,
    index: {
      type: Number,
      default: -1
    },
    cartIsLoading: {
      type: Boolean,
      default: false
    },
    price: {},
    code: {},
    isSide: {
      type: Boolean,
      default: false
    },
    quantity: {
      type: Number,
      default: 1
    },

    immutable: {
      type: Boolean,
      default: false
    },

    isPartOfQuantityBasedPromotion: {
      type: Boolean,
      default: false
    }
  },

  components: { CommonPrice },

  data: () => ({
    currentOption: -1
  }),
  computed: {
    getOrderItemList() {
      return get(this.getServerCart, 'subOrderList[0].orderItemList', [])
    },
    menuItem() {
      const serverCart = this.getServerCart;
      const fullItem = this.findFullItem(this.item)
      if (fullItem && fullItem.relations && fullItem.relations.length > 0) {
        const hasQuantityRule = fullItem.relations.some(relation => 
          relation.charge && relation.charge.quantityRule
        )
      }
      if (this.item && this.item.code) {
        return fullItem
      }
      return {}
    },

    punchCardApplied() {
      return this.getServerPunchCards && this.getServerPunchCards.length ?
        this.getServerPunchCards.findIndex(serverCard => serverCard.appliedItemUuids.includes(this.menuItem.uuid)) >= 0 :
        false
    },

    isQuantityBasedPromotion() {
      if (this.isPartOfQuantityBasedPromotion) {
        return true
      }
      if (this.menuItem && this.menuItem.relations && this.menuItem.relations.length > 0) {
        const hasQuantityRule = this.menuItem.relations.some(relation => 
          relation.charge && relation.charge.quantityRule
        )
        return hasQuantityRule
      }
      
      return false
    },

    getOriginalPrice() {
      if (this.menuItem.unitPrice) {
        return this.menuItem.unitPrice
      }
      if (this.item && this.item.childItemList && this.item.childItemList.length > 0) {
        for (const child of this.item.childItemList) {
          if (child.relation && child.unitPrice) {
            return child.unitPrice
          }
        }
      }
      return this.menuItem.itemPrice || 0
    },

    ...mapGetters([
      'getServerCart',
      'storeIsAvailable',
      'sumLocalMenuItem',
      'getLocalCart',
      'getServerPunchCards',
      'findFullItem'
    ])
  },

  methods: {
      getLowestNonZero(a, b) {
        const aVal = parseFloat(a) || 0;
        const bVal = parseFloat(b) || 0;
        if (aVal === 0 && bVal === 0) return 0;
        if (aVal === 0) return bVal;
        if (bVal === 0) return aVal;
        return Math.min(aVal, bVal);
      },
    truncate(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
    handleIncrement(index) {
      if (!this.cartIsLoading) {
        this.incrementCart(index)
      }
    },
    handleDecrement(index) {
      if (!this.cartIsLoading) {
        this.decrementCart(index)
      }
    },
    applyPunchCards(menuItem) {
      if (this.getServerPunchCards && this.getServerPunchCards.length) {
        const filtered = this.getServerPunchCards.filter(punchCard => punchCard.appliedItemUuids.includes(menuItem.uuid))

        if (filtered && filtered.length)
          return filtered.reduce((a, b) => {
            let qty = 1

            // When the cart gets split up, the punchCard contains the total price for all menuItems
            if (menuItem.qty != b.qty)
              qty = menuItem.qty / b.qty

            return a + ((+b.discountAmount*qty).toFixed(2)*-1 || 0)
          }, 0)
      }

      return 0
    },

    groupOptions(modifier) {
      if (modifier.pizzaTopping) {
        let _configItems = [[], [], []]

        modifier.attrValueList.forEach(opt => {
          _configItems[opt.option || 0].push(opt)
        })

        // Only show if anything other than all whole was selected
        if (_configItems[1].length === modifier.attrValueList.length) {
          modifier.pizzaTopping = false
          return modifier.attrValueList
        }

        return _configItems.flat()
      }

      return modifier.attrValueList
    },


    getOptionText(configIndex, values) {
      if (configIndex == 0 || values[configIndex].option != values[configIndex-1].option) {
        if (values[configIndex].option == 0) {
          return 'Left Side'
        } else if (values[configIndex].option == 1) {
          return 'Whole'
        } else if (values[configIndex].option == 2) {
          return 'Right Side'
        }
      }
    },

    initEdit(menuItem, index) {
      // Don't allow edit when the parent component says it's immutable (checkout page)
      if (this.immutable)
        return

      // Re-search using the index so that side options will start from the base item
      this.setIsCartItem(true)
      const isInGroupOrder = this.$store.getters['groupOrder/isInGroupOrder']
      const isInSharedCart = this.$store.getters['sharedCart/isActive']
      const groupOrderItems = isInGroupOrder ? (this.$store.getters['groupOrder/myCartItems'] || []) : []
      // Group order and shared cart both hand this component server-derived items
      // (itemAttributeList/childItemList already resolved, no local-cart index to
      // look up) via the `item` prop directly -- unlike the plain local-cart case
      // below, there's no separate by-index re-fetch needed or possible: shared
      // cart's items live across multiple subOrders (fired rounds + the current
      // draft), not the single flat array getLocalCart/menuItem assume.
      const cartItem = isInGroupOrder
        ? (groupOrderItems[index] || this.menuItem)
        : isInSharedCart
          ? this.item
          : this.getLocalCart[index].menuItem

      // Mark this item as "being edited" for the duration of the dialog so a
      // background refetch (WS push/poll landing while the dialog is open)
      // can flag it stale instead of silently letting the save overwrite
      // someone else's concurrent change with no warning. Cleared on save
      // or cancel in menuItemConfig.vue's closeDialog.
      if (this.$store.getters['sharedCart/isActive'] && cartItem && cartItem.uuid) {
        this.$store.commit('sharedCart/SET_EDITING_ITEM_UUIDS', [cartItem.uuid])
      }
      // For group order and shared cart items, the backend cart already contains
      // all selections (itemAttributeList and childItemList with relation
      // children). Use it directly -- same server-derived shape in both cases.
      if (isInGroupOrder || isInSharedCart) {
        const menuDef = _.cloneDeep(this.findFullItem(cartItem) || cartItem)
        menuDef.qty = cartItem.qty || 1
        menuDef.specialRequest = cartItem.specialRequest || ''
        // Simple item: copy saved attribute selections
        if (cartItem.itemAttributeList && cartItem.itemAttributeList.length) {
          menuDef.itemAttributeList = _.cloneDeep(cartItem.itemAttributeList)
        }
        // Relations item: map backend childItemList → relations[i].selectedItem
        // Look up the full menu definition for each child so attributes.Configurable is present
        if (cartItem.childItemList && cartItem.childItemList.length && menuDef.relations && menuDef.relations.length) {
          const self = this
          cartItem.childItemList.forEach(function(relationWrapper, i) {
            const relation = menuDef.relations[i]
            if (!relation) return
            const cartChild = relationWrapper.childItemList && relationWrapper.childItemList[0]
            if (cartChild) {
              const childMenuDef = self.findFullItem(cartChild)
              const selectedChild = _.cloneDeep(childMenuDef || cartChild)
              // Overlay saved attribute selections from cart data
              if (cartChild.itemAttributeList && cartChild.itemAttributeList.length) {
                selectedChild.itemAttributeList = _.cloneDeep(cartChild.itemAttributeList)
              }
              selectedChild.qty = cartChild.qty || 1
              selectedChild.uuid = cartChild.uuid
              relation.selectedItem = [selectedChild]
            }
          })
        }
        menuDef.childItemList = _.cloneDeep(cartItem.childItemList)
        this.setWorkingMenuItem(menuDef)
        this.$store.commit('SET_IS_OPTION', false)
        this.openMenuItemDialog()
        this.setCartItemIndex(index)
        return
      }
      if (this.parent && this.parent.childItemList) {
        let parentChildItem = this.parent.childItemList.find(child => child.code === cartItem.code)
        if (!parentChildItem && cartItem.externalId) {
          parentChildItem = this.parent.childItemList.find(child => child.externalId === cartItem.externalId)
        }
        if (!parentChildItem && cartItem.name) {
          parentChildItem = this.parent.childItemList.find(child => child.name === cartItem.name)
        }
        const originalMenuItem = this.findFullItem(cartItem)
        // For group order edits, cartItem already has the user's saved selections
        const savedAttributes = isInGroupOrder && cartItem.itemAttributeList && cartItem.itemAttributeList.length
          ? cartItem.itemAttributeList
          : null
        if (parentChildItem) {
          const workingMenuItem = _.cloneDeep({
            ...originalMenuItem,
            qty: cartItem.qty || 1,
            specialRequest: cartItem.specialRequest || '',
            itemAttributeList: savedAttributes || originalMenuItem.itemAttributeList || [],
            price: parentChildItem.price,
            subTotal: parentChildItem.subTotal,
            unitPrice: parentChildItem.unitPrice
          })
          this.setWorkingMenuItem(workingMenuItem)
        } else {
          let matchingChildItem = null
          for (const parentChild of this.parent.childItemList) {
            if (parentChild.externalId === cartItem.externalId ||
                parentChild.name === cartItem.name ||
                parentChild.code === cartItem.code) {
              matchingChildItem = parentChild
              break
            }
          }

          if (matchingChildItem) {
            const workingMenuItem = _.cloneDeep({
              ...originalMenuItem,
              qty: cartItem.qty || 1,
              specialRequest: cartItem.specialRequest || '',
              itemAttributeList: savedAttributes || originalMenuItem.itemAttributeList || [],
              price: matchingChildItem.price,
              subTotal: matchingChildItem.subTotal,
              unitPrice: matchingChildItem.unitPrice
            })
            this.setWorkingMenuItem(workingMenuItem)
          } else {
            const workingMenuItem = _.cloneDeep({
              ...originalMenuItem,
              qty: cartItem.qty || 1,
              specialRequest: cartItem.specialRequest || '',
              itemAttributeList: savedAttributes || originalMenuItem.itemAttributeList || [],
            })

            this.setWorkingMenuItem(workingMenuItem)
          }
        }
      } else {
        const fallbackItem = this.findFullItem(cartItem)
        if (isInGroupOrder && cartItem.itemAttributeList && cartItem.itemAttributeList.length) {
          fallbackItem.itemAttributeList = cartItem.itemAttributeList
        }
        this.setWorkingMenuItem(_.cloneDeep(fallbackItem))
      }
      
      this.$store.commit('SET_IS_OPTION', false)
      this.openMenuItemDialog()
      this.setCartItemIndex(index)
    },

    findDisplayText(menuItem) {
      const translations = get((get(menuItem, 'nameTranslation', null) || get(menuItem, 'name', null)), 'translations');
      const text = matchTranslation(translations) || menuItem.name || menuItem.value || '';

      if (!text || typeof text !== 'string') {
        return '';
      }

      const words = text.split(' ');
      const processedWords = words.map(word => {
        return word.length > 24 ? this.truncate(word, 23) : word;
      });
      return processedWords.join(' ').trim();
    },

    ...mapActions([
      'setWorkingMenuItem',
      'openMenuItemDialog',
      'setIsCartItem',
      'setCartItemIndex',
      'incrementCart',
      'decrementCart'
    ])
  }
}
</script>

<style scoped>
  #CartMenuItemDisplay {
    padding-right: 11px;
    font-size: var(--text-size-1);
  }
  .clickable-item {
    cursor: pointer;
  }
  .cart-list {
    padding: 0px;
    list-style: none;
  }
  .special-request {
    color: #999999;
    word-break: break-word;
    overflow-wrap: break-word;
  }
  
  .price-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    max-width: 100%;
    word-wrap: break-word;
  }
  
  .strikethrough-price {
    text-decoration: line-through !important;
    text-decoration-color: red;
    white-space: nowrap;
  }
  
  .discounted-price {
    white-space: nowrap;
  }
</style>
